module.exports = __webpack_public_path__ + "img/xwzx.cf425e02.png";